import "./src/fonts.css";
import "katex/dist/katex.min.css";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";
import React from "react";
import { RootLayout } from "./src/components/RootLayout";

export const wrapRootElement = ({ element }) => {
  return <RootLayout>{element}</RootLayout>;
};
